
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class AccountingPeriodDetailsGrid extends Serenity.EntityGrid<AccountingPeriodDetailsRow, any> {
        protected getColumnsKey() { return 'Finance.AccountingPeriodDetails'; }
        protected getDialogType() { return AccountingPeriodDetailsDialog; }
        protected getIdProperty() { return AccountingPeriodDetailsRow.idProperty; }
        protected getInsertPermission() { return AccountingPeriodDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return AccountingPeriodDetailsRow.localTextPrefix; }
        protected getService() { return AccountingPeriodDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}